<template>
  <lw-overlay
    :size="'c1'"
    :colour="'cream'"
    :close-to="'rates'"
  >
    <div class="grid grid-columns-4_md">
      <transition
        :name="transitionName"
        mode="out-in">
        <router-view/>
      </transition>
    </div>
  </lw-overlay>
</template>

<script>
import Overlay from '../livewires/Overlay'

export default {
  components: {
    lwOverlay: Overlay
  },
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  watch: {
    '$route' (to, from) {
      const toArray = to.path.split('/')
      const toStep = toArray[3]
      const fromArray = from.path.split('/')
      const fromStep = fromArray[3]
      if (toStep > fromStep) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>
